import { UserArchivedFilter } from '../enums/user-request/user-archived-filter.enum';

export class AdvancedRosterSearch {
    Name: string;
    Status: number;
    ApproverUserId: string;
    Act48Status: number;
    GroupIDs: string[];
    UserArchivedFilter: UserArchivedFilter;
}